function injectStyle (ssrContext) {
  require("!!../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/_vue-loader@13.0.4@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-273ac036\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/_vue-loader@13.0.4@vue-loader/lib/selector?type=styles&index=0!./leftMenu.vue")
}
var normalizeComponent = require("!../../node_modules/_vue-loader@13.0.4@vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../node_modules/_vue-loader@13.0.4@vue-loader/lib/selector?type=script&index=0!./leftMenu.vue"
/* template */
import __vue_template__ from "!!../../node_modules/_vue-loader@13.0.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-273ac036\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../node_modules/_vue-loader@13.0.4@vue-loader/lib/selector?type=template&index=0!./leftMenu.vue"
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-273ac036"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/leftMenu.vue
// module id = Oj91
// module chunks = 1